/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { selectCurrentEmpid, selectCurrentUserManagerLevel } from '../../pages/login/authSlice';
import { useGetApprovalWindowNotificationQuery } from '../../pages/compensation/compensationSlice';
import {
    ALERT_AGENT_APPROVAL,
    ALERT_MANAGER_APPROVAL,
    ALERT_TL_APPROVAL,
    MANAGERDASHBOARD,
    MYMETRICS,
    ROLES,
    SCORECARDDASHBOARD,
} from '../../constants';
import networkToastService from '../networkStatus/networkToastService';

import './approvalWindowNotificationToast.scss';

export const ApprovalWindowNotificationToast = () => {
    const navigate = useNavigate();
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);

    const {
        data: notificationData, //, isFetching: notificationDataFetching
    } = useGetApprovalWindowNotificationQuery(
        {
            employeeNumber: loggedEmpNum,
            managerLevel: userManagerLevel?.toLowerCase(),
        },
        { skip: !loggedEmpNum || !userManagerLevel }
    );

    useEffect(() => {
        networkToastService.hideApproval();
    }, [loggedEmpNum]); // eslint-disable-line

    useEffect(() => {
        if (networkToastService.isApprovalShown) {
            networkToastService.approvalOnClick = redirection;
        }
    }); 

    const redirection = () => {
        let navLink = '';
        if (ROLES.Agents.includes(userManagerLevel))
            navLink = `${MYMETRICS}/${loggedEmpNum}/${notificationData?.data[0]?.scorecard_version_id}/${notificationData?.data[0]?.year}-${notificationData?.data[0]?.month}`;
        else if (ROLES.Supervisor.includes(userManagerLevel))
            navLink = `${SCORECARDDASHBOARD}/${notificationData?.data[0]?.scorecard_version_id}/${notificationData?.data[0]?.year}-${notificationData?.data[0]?.month}`;
        else
            navLink = `${MANAGERDASHBOARD}/4/${notificationData?.data[0]?.scorecard_version_id}/${notificationData?.data[0]?.year}-${notificationData?.data[0]?.month}/${loggedEmpNum}`;
        navigate(navLink, { replace: true });
        networkToastService.hideApproval();
    };

    useEffect(() => {
        if (notificationData?.data.length > 0) {
            let toastMsg = '';
            if (ROLES.Agents.includes(userManagerLevel)) toastMsg = ALERT_AGENT_APPROVAL;
            else if (ROLES.Supervisor.includes(userManagerLevel)) toastMsg = ALERT_TL_APPROVAL;
            else if (ROLES.Manager.includes(userManagerLevel)) toastMsg = ALERT_MANAGER_APPROVAL;

            networkToastService.showApproval(toastMsg, redirection);
        } else {
            networkToastService.hideApproval();
        }
    }, [notificationData]); 

    return null;
};
